export default __webpack_public_path__ + "static/O0257-9b1a2d9051873f16b2f408d1bed82551.png";